import {useEffect} from 'react'

import {STOCKTAKE_LINE_SORT_OPTIONS} from '../../common/constants/Stocktakes.js'
import {stocktakeSelector} from '../../data/stocktakes.js'
import Modals from '../StocktakeListPage/Modals/index.js'
import ActionsForSelected from '../StocktakeListPage/ActionsForSelected.js'
import {
  countSelector,
  refreshStocktakeLines,
  selectedSKUsSelector,
  setSort,
  stocktakeDetailFormSelector,
  stocktakeDetailQuerySelector,
  stocktakeDetailReferenceIDSelector,
} from './stocktakeDetailFunctions.js'
import {hasStocktakePermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import {onlyIfForm, useSelector} from '../../store.js'
import Sidebar from './Sidebar.js'
import StocktakeDetailOmniBar from './StocktakeDetailOmniBar.js'
import List, {StocktakeDetailExpandAll} from './List.js'
import {showStocktakeDetailFilterModal} from '../StocktakeListPage/Modals/StocktakeDetailFilterModal/stocktakeDetailFilterModalFunctions.js'
import Sort from '../../common/components/List/Sort.js'
import ListItemsCount from '../../common/components/List/ListItemsCount.js'
import {plural} from '../../common/components/Plural.js'
import RefreshButton from '../../common/components/List/RefreshButton.js'
import {navigateToStocktakeListPage} from '../StocktakeListPage/stocktakeListFunctions.js'
import FiltersButton from '../../common/components/FiltersButton.js'

function StocktakeDetailPage({form}) {
  const referenceID = useSelector(stocktakeDetailReferenceIDSelector)
  const stocktake = useSelector((state) =>
    stocktakeSelector(state, {referenceID}),
  )
  const hasStocktakePermission = useSelector(hasStocktakePermissionSelector)
  const query = useSelector(stocktakeDetailQuerySelector)
  const count = useSelector(countSelector)
  const selectedSKUs = useSelector(selectedSKUsSelector)

  useEffect(() => {
    document.title = referenceID ? `${referenceID} - Stocktake` : 'Stocktake'
  }, [referenceID])

  if (!hasStocktakePermission) {
    return <NoPermissionsPage />
  }

  if (!referenceID) {
    return null
  }

  if (form.isLoading) {
    return (
      <div className="margin-top-40">
        <div className="loading align-center">
          <span className="list-processing animate-spin v-align-middle" />
          <strong className="inline-block v-align-middle fs-02 op-75 margin-left-5">
            Loading...
          </strong>
        </div>
      </div>
    )
  }

  if (!stocktake) {
    return (
      <dl className="list--empty-content">
        <dt className="fs-02 margin-bottom-20">
          <span>Stocktake ‘{referenceID}’ could not be found</span>
        </dt>
      </dl>
    )
  }

  return (
    <div id="iverson-page">
      <Modals />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <div className="wrap--list-header flex--justify padding-top-10 padding-bottom-10">
              <ul className="list list--no-style">
                <li className="inline-block margin-right-3">
                  <ListItemsCount
                    limit={query.limit}
                    offset={query.offset}
                    count={count}
                    thing={plural(count)`Product${['s']}`}
                  />
                </li>
                <li
                  className="inline-block margin-right-3 tooltip--top"
                  data-hint="Refresh the product list"
                >
                  <RefreshButton onClick={() => refreshStocktakeLines()} />
                </li>
                <StocktakeDetailExpandAll />
                <li className="inline-block divider--left">
                  <FiltersButton
                    onClick={() => showStocktakeDetailFilterModal({query})}
                  />
                </li>
                <Sort
                  items={STOCKTAKE_LINE_SORT_OPTIONS}
                  value={query.sort}
                  onChange={(value) => setSort(value)}
                />
                <ActionsForSelected
                  referenceIDs={[referenceID]}
                  selectedSKUs={selectedSKUs}
                />
                <li className="inline-block divider--left">
                  <button
                    className="btn btn--action v-align-base"
                    type="button"
                    onClick={() => navigateToStocktakeListPage()}
                  >
                    Stocktakes
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="wrap--row">
          <div className="medium-12 columns flex">
            <StocktakeDetailOmniBar />
          </div>
        </div>
        <div className="wrap--row margin-top-20">
          <div className="medium-8 columns">
            <List />
          </div>
          <div className="columns medium-4">
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  )
}

export default onlyIfForm(StocktakeDetailPage, stocktakeDetailFormSelector)
